import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import MultipleSelect from '../common/MultipleSelect'
import { AXIOS } from '../../api'
import { useHistory } from 'react-router-dom'

import { setFetch, setLoading } from '../../redux/actions'

const ConfigActivite = ({ toast, Toasky }) => {
    const dispatch = useDispatch()
    const history = useHistory()
    const { activites, configurations, articles } = useSelector(state => state.fetch)
    const { fetch, topbar } = useSelector(state => state.config)

    const [addresses, setAddresses] = useState([])
    const [activite, setActivite] = useState({
        aid: '',
        name: '',
        classement: '',
        status: '',
        menu: '',
        color1: ''
    })

    useEffect(() => {
        let ADDRESSES = configurations[0]?.addresses.replace(/\s/g, '').split(',')
        setAddresses(ADDRESSES)
    }, [configurations])

    useEffect(() => {
        if (topbar?.length > 0) {
            setActivite(activites.filter(({ aid }) => aid === topbar)[0])
        }
    }, [activites, topbar])

    const { handleSubmit, register, errors } = useForm()
    const onSubmit = async values => {
        try {
            dispatch(setLoading(true))
            values['accueilPosts'] = accueil
            if (accueil === '') values['accueilPosts'] = null
            // 👽 UPDATE CONFIGURATION REQUEST
            await AXIOS.patch(`/api/v1/activites/${aid}`, values)
            history.push('/configurations')
            toast(<Toasky body="Les changements est bien effectué." />)
            dispatch(setFetch(!fetch))
            dispatch(setLoading(false))
        } catch (error) {
            console.log(error)
        }
    }

    const { aid, name, color1, linkedArticles, accueilPosts, logicielUrl, logicielPort, logicielId, logicielKey } = activite

    const [accueil, setAccueil] = useState(null)

    useEffect(() => {
        // console.log(activite)
    }, [topbar, activite])

    return (
        <div className="configurations__bodyWrapper" style={{ marginBottom: '0' }}>
            <div className="gestion__header" style={{ marginBottom: '5rem' }}>
                <h4 className="gestion__title">Configuration activité</h4>
                <h5 className="gestion__total" style={{ color: color1, textTransform: 'uppercase' }}>{name}</h5>
            </div>
            <div className="configurations__body">
                <form onSubmit={handleSubmit(onSubmit)} className="configurations__form" noValidate="novalidate">

                    <div className="form__inputbox" style={{ width: '485px' }}>
                        <label htmlFor="linked_formule1" className="form__label">Articles liés</label>
                        <input defaultValue={linkedArticles} multiple type="email" name="linkedArticles" ref={register()} list="linkedArticles" className="form__input" style={{ padding: '0 8px 0 14px' }} />
                        <datalist id="linkedArticles">
                            {articles.map(({ id, name }) => <option className="form__dropdown" key={id} value={id}>{name}</option>)}
                        </datalist>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '2rem', width: '485px' }}>
                        <label htmlFor="name" className="form__label">Poste accueil</label>
                        <MultipleSelect addresses={addresses} setAccueil={setAccueil} defaultValue={accueilPosts?.replace(/\s/g, '').split(',')} color={color1} />
                    </div>


                    <div className="configurations__formWrapper">
                        <div className="configurations__inputWrapper">
                            <div className="form__inputbox" style={{ width: '73%', marginRight: '2rem' }}>
                                <label htmlFor="logicielUrl" className="form__label">logiciel métier url</label>
                                <input name="logicielUrl" defaultValue={logicielUrl} ref={register()} type="text" className="form__input" />
                            </div>
                            <div className="form__inputbox" style={{ width: '140px' }}>
                                <label htmlFor="logicielPort" className="form__label">logiciel métier port</label>
                                <input name="logicielPort" defaultValue={logicielPort} ref={register()} type="text" className="form__input" />
                            </div>
                        </div>
                    </div>

                    <div className="configurations__formWrapper">
                        <div className="configurations__inputWrapper">
                            <div className="form__inputbox" style={{ width: '40%', marginRight: '2rem' }}>
                                <label htmlFor="logicielId" className="form__label">logiciel métier id</label>
                                <input name="logicielId" defaultValue={logicielId} ref={register()} type="text" className="form__input" />
                            </div>
                            <div className="form__inputbox" style={{ width: '60%' }}>
                                <label htmlFor="logicielKey" className="form__label">logiciel métier key</label>
                                <input name="logicielKey" defaultValue={logicielKey} ref={register()} type="text" className="form__input" />
                            </div>
                        </div>
                    </div>

                    <button className="configurations__button" style={{ backgroundColor: color1 }}>Sauvegarder</button>

                </form>
            </div>
        </div>
    );
}

export default ConfigActivite